import * as types from './UserManagement.types';

// Fetch users with management details (with pagination and search)
export const fetchUsers = (params = {}) => ({
  type: types.USER_MANAGEMENT_FETCH_USERS,
  payload: params,
});

export const fetchUsersSuccess = (data) => ({
  type: types.USER_MANAGEMENT_FETCH_USERS_SUCCESS,
  payload: data,
});

export const fetchUsersError = (error) => ({
  type: types.USER_MANAGEMENT_FETCH_USERS_ERROR,
  payload: error,
});

// Fetch single user details
export const fetchUserDetails = (userId) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_DETAILS,
  payload: userId,
});

export const fetchUserDetailsSuccess = (user) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_DETAILS_SUCCESS,
  payload: user,
});

export const fetchUserDetailsError = (error) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_DETAILS_ERROR,
  payload: error,
});

// Reset password
export const resetPassword = (userId) => ({
  type: types.USER_MANAGEMENT_RESET_PASSWORD,
  payload: userId,
});

export const resetPasswordSuccess = (message) => ({
  type: types.USER_MANAGEMENT_RESET_PASSWORD_SUCCESS,
  payload: message,
});

export const resetPasswordError = (error) => ({
  type: types.USER_MANAGEMENT_RESET_PASSWORD_ERROR,
  payload: error,
});

// Set password
export const setPassword = (email, password) => ({
  type: types.USER_MANAGEMENT_SET_PASSWORD,
  payload: { email, password },
});

export const setPasswordSuccess = (message) => ({
  type: types.USER_MANAGEMENT_SET_PASSWORD_SUCCESS,
  payload: message,
});

export const setPasswordError = (error) => ({
  type: types.USER_MANAGEMENT_SET_PASSWORD_ERROR,
  payload: error,
});

// Fetch user representatives
export const fetchUserRepresentatives = (userId) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES,
  payload: userId,
});

export const fetchUserRepresentativesSuccess = (representatives) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_SUCCESS,
  payload: representatives,
});

export const fetchUserRepresentativesError = (error) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_ERROR,
  payload: error,
});

// Fetch user powers
export const fetchUserPowers = (userId) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_POWERS,
  payload: userId,
});

export const fetchUserPowersSuccess = (powers) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_POWERS_SUCCESS,
  payload: powers,
});

export const fetchUserPowersError = (error) => ({
  type: types.USER_MANAGEMENT_FETCH_USER_POWERS_ERROR,
  payload: error,
});

// Update search term
export const setSearch = (searchTerm) => ({
  type: types.USER_MANAGEMENT_SET_SEARCH,
  payload: searchTerm,
});

// Update filters
export const setFilters = (filters) => ({
  type: types.USER_MANAGEMENT_SET_FILTERS,
  payload: filters,
});

// Update pagination
export const setPagination = (pagination) => ({
  type: types.USER_MANAGEMENT_SET_PAGINATION,
  payload: pagination,
});

// Legacy actions (keeping for future use)
export const createUser = (userData) => ({
  type: types.USER_MANAGEMENT_CREATE_USER,
  payload: userData,
});

export const createUserSuccess = (user) => ({
  type: types.USER_MANAGEMENT_CREATE_USER_SUCCESS,
  payload: user,
});

export const createUserError = (error) => ({
  type: types.USER_MANAGEMENT_CREATE_USER_ERROR,
  payload: error,
});

export const updateUser = (userId, userData) => ({
  type: types.USER_MANAGEMENT_UPDATE_USER,
  payload: { userId, userData },
});

export const updateUserSuccess = (user) => ({
  type: types.USER_MANAGEMENT_UPDATE_USER_SUCCESS,
  payload: user,
});

export const updateUserError = (error) => ({
  type: types.USER_MANAGEMENT_UPDATE_USER_ERROR,
  payload: error,
});

export const deleteUser = (userId) => ({
  type: types.USER_MANAGEMENT_DELETE_USER,
  payload: userId,
});

export const deleteUserSuccess = (userId) => ({
  type: types.USER_MANAGEMENT_DELETE_USER_SUCCESS,
  payload: userId,
});

export const deleteUserError = (error) => ({
  type: types.USER_MANAGEMENT_DELETE_USER_ERROR,
  payload: error,
});

// Update user representatives
export const updateUserRepresentatives = (userId, representativesArray) => ({
  type: types.USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES,
  payload: { userId, representativesArray },
});

export const updateUserRepresentativesSuccess = (message) => ({
  type: types.USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_SUCCESS,
  payload: message,
});

export const updateUserRepresentativesError = (error) => ({
  type: types.USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_ERROR,
  payload: error,
});

// Search natural entities for representatives
export const searchNaturalEntities = (legalUserId, params = {}) => ({
  type: types.USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES,
  payload: { legalUserId, params },
});

export const searchNaturalEntitiesSuccess = (data) => ({
  type: types.USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_SUCCESS,
  payload: data,
});

export const searchNaturalEntitiesError = (error) => ({
  type: types.USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_ERROR,
  payload: error,
});

// Create user power (legal entity file)
export const createUserPower = (userId, powerData) => ({
  type: types.USER_MANAGEMENT_CREATE_USER_POWER,
  payload: { userId, powerData },
});

export const createUserPowerSuccess = (power) => ({
  type: types.USER_MANAGEMENT_CREATE_USER_POWER_SUCCESS,
  payload: power,
});

export const createUserPowerError = (error) => ({
  type: types.USER_MANAGEMENT_CREATE_USER_POWER_ERROR,
  payload: error,
});

// Delete user power (legal entity file)
export const deleteUserPower = (userId, powerId) => ({
  type: types.USER_MANAGEMENT_DELETE_USER_POWER,
  payload: { userId, powerId },
});

export const deleteUserPowerSuccess = (powerId) => ({
  type: types.USER_MANAGEMENT_DELETE_USER_POWER_SUCCESS,
  payload: powerId,
});

export const deleteUserPowerError = (error) => ({
  type: types.USER_MANAGEMENT_DELETE_USER_POWER_ERROR,
  payload: error,
});

// Replace user power (delete + create)
export const replaceUserPower = (userId, powerId, powerData) => ({
  type: types.USER_MANAGEMENT_REPLACE_USER_POWER,
  payload: { userId, powerId, powerData },
});

export const replaceUserPowerSuccess = (power) => ({
  type: types.USER_MANAGEMENT_REPLACE_USER_POWER_SUCCESS,
  payload: power,
});

export const replaceUserPowerError = (error) => ({
  type: types.USER_MANAGEMENT_REPLACE_USER_POWER_ERROR,
  payload: error,
});